/**
 * This script is responsible for loading recent videos dynamically
 * using AJAX. It fetches the recent videos from the server and updates
 * the HTML content of the recent video container.
 * 
 * It requires data to be available in the global `LOADERDATA_RVL` object,
 * created via the "wp_add_inline_script" function in PHP. That object should
 * contain the following properties:
 * - `ajaxUrl`: The URL to the AJAX handler.
 */
(function() {
    fetch(`${LOADERDATA_RVL.ajaxUrl}?action=get_recent_videos`)
        .then(res => {
            if (!res.ok) {
                throw new Error('Network request failed');
            }
            return res.json();
        })
        .then(json => {
            if (json.success) {
                const videosMarkup = json.markup;
                const videosContainer = document.querySelector('#recent-videos-container');
                if (!videosContainer) {
                    throw new Error('Recent videos container not found');
                }
                videosContainer.innerHTML = videosMarkup;
            } else {
                throw new Error(json.message ?? 'Unknown error');
            }
        })
        .catch(err => {
            console.error('Error fetching recent videos:', err);
        });
})();